import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Notification = ({ notification, isLast }) => {
  const { title, body } = notification;
  return (
    <li
      className={classNames('alert mb-0 rounded-0 py-2 px-0', {
        'border-0': isLast,
        'border-x-0 border-top-0': !isLast
      })}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div
          className="d-flex align-items-center"
          style={{
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
          }}
        >
          <FontAwesomeIcon icon="circle" className="fs--2 text-primary" />
          <div style={{ minWidth: 0 }}>
            <strong>
              <p
                style={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden'
                }}
                className="fs--1 ps-2 mb-0"
              >
                {title}
              </p>
            </strong>
            <p
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden'
              }}
              className="fs--1 ps-2 mb-0"
            >
              {body}
            </p>
          </div>
        </div>
      </div>
    </li>
  );
};

Notification.propTypes = {
  notification: PropTypes.object,
  isLast: PropTypes.bool.isRequired
};

export default Notification;
